/**
 * @readonly
 * @enum {Number}
 */
const tournamentLengthsEnum = [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8
]

const defaultTournamentLength = 2;

export {
    tournamentLengthsEnum,
    defaultTournamentLength
}
